import React from 'react';
import PropTypes from 'prop-types';
import QuickTipSnippet from './staticSnippets/QuickTipSnippet';
import HelpTextSnippet from './staticSnippets/HelpTextSnippet';

const LabelledInputLayout = ({
  id,
  label = '',
  isRequired = false,
  className = '',
  errorMsg = [],
  touched = false,
  children,
}) => {
  const fullClassName = `${className} ${(touched && errorMsg.length) ? 'has-error' : ''} quick-tip-anchor`;
  return (
    <div data-testid="labelled-input" className={fullClassName} style={{ marginBottom: '1rem' }}>
      <QuickTipSnippet field={id} />
      <label htmlFor={id}>
        <div style={{ marginBottom: '0.5rem' }}>
          {label && (
            <span id={`${id}_label`} className="press-release-content__label">{label}</span>
          )}
          {isRequired && (
            <span className="form__required-tag">*</span>
          )}
        </div>
        <HelpTextSnippet field={id} />
        {children}
        <HelpTextSnippet field={id} isPost />
        {touched && errorMsg.length > 0 && (
          <p className="form-error__message">
            {Array.isArray(errorMsg) ? (
              errorMsg.map((error, index, allErrors) => {
                if (!error) { // skip empty errors
                  return '';
                }
                if (index === allErrors.length - 1) { // last item
                  return error;
                }
                return (<>{error}<br /></>); // append newline
              })
            ) : (
              errorMsg
            )}
          </p>
        )}
      </label>
    </div>
  );
};

LabelledInputLayout.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  errorMsg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  touched: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default LabelledInputLayout;
